import type { IconSvgObject } from './types';

const RotateCcwSquareIcon: IconSvgObject = [
  ["path", { d: "M12.5 5H18.5C19.6046 5 20.5 5.89543 20.5 7V9M20.5 13V20C20.5 21.1046 19.6046 22 18.5 22H5.5C4.39543 22 3.5 21.1046 3.5 20V7C3.5 5.89543 4.39543 5 5.5 5H7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 2L11.5 5L14.5 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RotateCcwSquareIcon;
